import React from 'react'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SelectUI from '../../../widgets/input/SelectUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CardUI from '../../../widgets/layout/CardUI'
import './FixedDepositList.css'

const FixedDepositListUI = ({
  context, accountNumber, onRefreshClick,
  fdTransferList, totals, fdTransactions, fdMonthlyTotals, fdTxnList,
  financialYear, financialYearList, onFinancialYearChange
}) =>
  <div className='pg_su_fd'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          financialYear={financialYear}
          financialYearList={financialYearList}
          onFinancialYearChange={onFinancialYearChange}
        />
      }
    />
    <FDMonthlyUI accountNumber={accountNumber} fdTransactions={fdTransactions} fdMonthlyTotals={fdMonthlyTotals} />
    {
      fdTransferList.length === 0 &&
      <EmptyListUI className='g_m_top_100'
        context={context}
        createEnabled={false}
        createDisabledMessageLabel='No fixed deposits'
      />
    }
    {
      fdTransferList.length > 0 &&
      <div>
        <FD accountNumber={accountNumber} fdTransferList={fdTransferList} totals={totals} />
      </div>
    }
    {
      fdTxnList &&
      <FDTxnListUI fdTxnList={fdTxnList} />
    }
  </div>

const FDMonthlyUI = ({ accountNumber, fdTransactions, fdMonthlyTotals }) =>
  <CardUI className='g_m_top_100'>
    <table className='g_table_3'><tbody>
      <tr>
        <th />
        <th>Opening Balance</th>
        <th>FD Booked</th>
        <th>FD Withdrawal</th>
        <th>Closing Balance</th>
      </tr>
      {
        fdTransactions && fdTransactions.map((fd, i) =>
          <tr key={i}>
            <td>{fd.monthYear}</td>
            <td className='g_text_right g_p_left_100'>{fd.openingBalanceF4}</td>
            <td className='g_text_right g_p_left_100'>{fd.fdBookedAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{fd.fdWithdrawalAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{fd.runningBalanceF4}</td>
          </tr>
        )
      }
      {
        fdMonthlyTotals &&
        <tr>
          <td><b>Total</b></td>
          <td />
          <td className='g_text_right g_p_left_100'><b>{fdMonthlyTotals.fdBooked}</b></td>
          <td className='g_text_right g_p_left_100'><b>{fdMonthlyTotals.fdWithdrawal}</b></td>
          <td />
        </tr>
      }
    </tbody></table>
    <div className='g_text_right'><i>FD Withdrawal includes interest, hence interest gets deducted in
      the closing balance.</i></div>
  </CardUI>

const FDTxnListUI = ({ fdTxnList }) =>
  <CardUI className='g_m_top_100' title='All FD Transfers'>
    <table className='g_table_3'><tbody>
      <tr>
        <th>Date</th>
        <th>FD Booked</th>
        <th>FD Withdrawal</th>
        <th>Closing Balance</th>
      </tr>
      {
        fdTxnList && fdTxnList.map((fd, i) =>
          <tr key={i}>
            <td>{fd.transactionDateF}</td>
            <td className='g_text_right g_p_left_100'>
              {
                fd.amount < 0 &&
                <>({fd.amountF1})</>
              }
            </td>
            <td className='g_text_right g_p_left_100'>
              {
                fd.amount >= 0 &&
                <>{fd.amountF1}</>
              }
            </td>
            <td className='g_text_right g_p_left_100'>
              {
                fd.balanceAmount >= 0 &&
                <>{fd.balanceAmountF1}</>
              }
              {
                fd.balanceAmount < 0 &&
                <>({fd.balanceAmountF1})</>
              }
            </td>
          </tr>
        )
      }
    </tbody></table>
  </CardUI>

const FD = ({ accountNumber, fdTransferList, totals }) =>
  <CardUI title={`FD in ${accountNumber}`} className='g_m_top_100'>
    <div className='g_flex_h g_flex_right'>
      Current FD booked:
      <BadgeUI className='g_m_left_50' label={`₹${totals.fdBookedCurrentF4}`} />
    </div>
    <table className='g_table_3'><tbody>
      <tr>
        <th>FD Account</th>
        <th>FD Booked</th>
        <th>FD Amount</th>
        <th>Withdrawal</th>
        <th>Amount</th>
        <th>Interest Earned</th>
      </tr>
      {
        fdTransferList.map((fd, i) =>
          <tr key={i}>
            <td>{fd.fdAccount}</td>
            <td className='g_text_right g_p_left_100'>{fd.fdBookedDateF}</td>
            <td className='g_text_right g_p_left_100'>{fd.fdBookedAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{fd.fdWithdrawalDateF}</td>
            <td className='g_text_right g_p_left_100'>{fd.fdWithdrawalAmountF4}</td>
            <td className='g_text_right g_p_left_100'>{fd.interestEarnedF4}</td>
          </tr>
        )
      }
      <tr>
        <td><b>Total</b></td>
        <td></td>
        <td className='g_text_right g_p_left_100'><b>{totals.fdBookedTotalF4}</b></td>
        <td></td>
        <td className='g_text_right g_p_left_100'><b>{totals.fdWithdrawalTotalF4}</b></td>
        <td className='g_text_right g_p_left_100'><b>{totals.fdInterestEarnedF4}</b></td>
      </tr>
    </tbody></table>
  </CardUI>

const ActionLeftUI = ({ onRefreshClick, accountNumber }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Fixed Deposits in {accountNumber}</b></span>
  </div>

const ActionRightUI = ({ financialYear, financialYearList, onFinancialYearChange }) =>
  <span className='g_flex_h g_flex_right'>
    <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
  </span>

export default FixedDepositListUI
